import { Select } from 'antd'
import { observer } from 'mobx-react-lite'
import type { DispatcherOption } from '@/Ship/Contracts/DashboardSummary'

interface DispatcherFilterSelectProps {
    value: number | null
    onChange: (value: number | null) => void
    options: DispatcherOption[]
    loading: boolean
    onSearch: (search: string) => void
    placeholder?: string
    minWidth?: number
}

/**
 * Searchable dispatcher dropdown used by the dashboard counters and
 * active-delays table headers. The component is dumb — `options` / `loading` /
 * `onSearch` come from a shared store (e.g. `DashboardStore`) so multiple
 * instances on the same page can share one fetched list.
 *
 * `value` is the dispatcher's numeric id (or `null` for "all"), matching the
 * `DispatcherOption.value` shape from the Ship contract.
 */
export const DispatcherFilterSelect = observer(({
    value,
    onChange,
    options,
    loading,
    onSearch,
    placeholder = 'Відповідальний диспетчер',
    minWidth = 280,
}: DispatcherFilterSelectProps) => {
    return (
        <Select<number | null>
            allowClear
            showSearch
            placeholder={placeholder}
            style={{ minWidth }}
            value={value}
            loading={loading}
            options={options}
            filterOption={false}
            onSearch={onSearch}
            onChange={(v) => onChange(v ?? null)}
        />
    )
})
